<template>
  <b-modal :title="`Add Device`" size="lg" v-model="visible" @ok="save" @cancel="hide" ok-title="Save" :ok-disabled="!canSave || saving">
    <b-row>
      <b-col cols="4">
        <b-form-group label="Type">
          <b-select :options="typeOptions" v-model="device.typeId"></b-select>
        </b-form-group>
      </b-col>
      <b-col cols="4">
        <b-form-group>
          <label for="name">Name</label>
          <b-form-input type="text" id="name" placeholder="Enter your device name" v-model="device.name" required></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="4" v-show="macAddressRequired">
        <b-form-group>
          <label for="name">MAC Address</label>
          <b-form-input type="text" id="name" placeholder="Device MAC Address" v-model="device.MACAddress" autocomplete="off" :required="macAddressRequired"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    canSave () {
      const macAddress = this.device.MACAddress ? this.device.MACAddress.replace(/[^A-Fa-f0-9]/g, '') : ''
      if (this.device.name && (!this.macAddressRequired || macAddress.length === 12) && this.device.typeId > 0) {
        return true
      }
      return false
    },
    typeOptions () {
      return [
        { value: null, text: 'Select One...', disabled: true }
      ].concat(this.deviceTypes.map((o) => {
        return { value: o.id, text: `${o.name}` }
      }))
    },
    macAddressRequired () {
      if (this.device.typeId > 0) {
        const type = this.deviceTypes.find(o => o.id === this.device.typeId)
        if (type.isSoftPhone) return false
      }
      return true
    },
    ...mapGetters({
      account: 'global/account'
    }),
  },
  data () {
    return {
      visible: false,
      saving: false,
      deviceTypes: [],
      device: {
        name: null,
        g729: false,
        ulaw: true,
        MACAddress: null,
      }
    }
  },
  methods: {
    async save () {
      this.saving = true
      this.device.accountId = this.account.id
      if (this.device.MACAddress) {
        this.device.MACAddress = this.device.MACAddress.replace(/[^A-Fa-f0-9]/g, '').toUpperCase()
      }
      const { data } = await this.$axios.post(`/v1/devices`, this.device)
      this.saving = false
      this.$emit('add', data)
      await this.$store.dispatch('account/getDevices')
      this.$snotify.success('Device Added')
    },
    show () {
      this.visible = true
    },
    hide () {
      this.visible = false
    },
    getDeviceTypes () {
      this.$axios.get(`/v1/devices/types`).then(({ data = [] }) => {
        this.deviceTypes = data
      })
    },
  },
  created () {
    this.getDeviceTypes()
  },
  mounted () {
    this.$bus.$on('modal:addDevice', () => {
      this.show();
    })
  },
  beforeDestroy () {
    this.$bus.$off('modal:addDevice')
  }
}
</script>
